import React, { type FunctionComponent } from 'react'
import { PageHeader } from '@retailer-platform/shared-components'
import { Breadcrumbs } from '@retailer-platform/shared-components'
import { ProductsBreadcrumbs } from 'domains/products/components/breadcrumbs/ProductsBreadcrumbs'
import { ProductsEditButtonAndModal } from 'domains/products/components/search/components/edit-product-button-and-modal/ProductsEditButtonAndModal'
import { type Product } from 'domains/products/components/view/utils/types'

interface ProductsViewHeaderProps {
  product: Product
  showInAssortment: boolean
}

export const ProductsViewHeader: FunctionComponent<ProductsViewHeaderProps> = ({
  product,
  showInAssortment,
}) => (
  <PageHeader
    addBottomPadding
    title={
      <ProductsBreadcrumbs>
        <Breadcrumbs>{product.productDisplayName}</Breadcrumbs>
      </ProductsBreadcrumbs>
    }
    actions={
      showInAssortment && (
        <ProductsEditButtonAndModal
          productId={product.productId}
          productName={product.productDisplayName}
          productUpc={product.productCodes?.[0]}
          showEditProduct={false}
          showInAssortment={showInAssortment}
        />
      )
    }
  />
)
